import "./nav.css";
import "./override.css";

import { Box } from "@chakra-ui/react";
import { ApexOnlineMenu } from "apex-online-menu";
import { withSession, WithSessionProps } from "ui-classic-common-library";

import { usePermissions } from "../../contexts/permissions";
import { getLegacyUrl } from "./utils/getLegacyUrl";
import { useMenuItemsQuery } from "./utils/useMenuItemsQuery";

interface PrimaryNavigationProps extends WithSessionProps {
  accountNumber?: string;
}

const PrimaryNavigation = ({
  accountNumber,
  handleLogout,
}: PrimaryNavigationProps) => {
  const { permissions } = usePermissions();
  const { data, isSuccess } = useMenuItemsQuery();

  if (isSuccess) {
    return (
      <Box>
        <ApexOnlineMenu
          items={data}
          userPermissions={{ permissions }}
          legacyUrl={getLegacyUrl()}
          showLogout={true}
          logout={handleLogout}
          accountNumber={accountNumber}
        />
      </Box>
    );
  }

  return null;
};

export default withSession(PrimaryNavigation);
